export const PlayIcon: React.FC<React.SVGAttributes<{}>> = props => (
    <svg viewBox="0 0 14 14" fill="none" {...props}>
        <path
            d="M2.97883 0.308689C1.71665 -0.415315 0.693359 0.177798 0.693359 1.63238V12.3666C0.693359 13.8226 1.71665 14.415 2.97883 13.6917L12.3611 8.31101C13.6237 7.58675 13.6237 6.41334 12.3611 5.68925L2.97883 0.308689Z"
            fill="currentColor"
        />
    </svg>
);
